import styled from 'styled-components';

import { Toaster } from '@zeal/web-ui';

export const StyledBanner = styled(Toaster)`
	position: absolute;
	left: 25%;
	top: 75px;
	z-index: 90;
	width: 55%;
`;
